module.exports = __webpack_public_path__ + "static/img/tuanwei.0315efbe.png";